/* eslint-disable @angular-eslint/component-selector */
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, inject, input, output, viewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject, fromEvent, merge, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, tap } from 'rxjs/operators';

export interface FileUpload {
  file: File;
  formData: FormData;
  fileReader: FileReader;
  objectUrl: string;
}

@Component({
  selector: 'cmg-clear2-ui-file-uploader-34',
  templateUrl: './file-uploader-3.4.component.html',
  styleUrls: ['./file-uploader-3.4.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FileUploader34Component implements OnInit, AfterViewInit, OnDestroy {
  private readonly _sanitizer = inject(DomSanitizer);

  readonly placeholder = input('Click or drag and drop to <span class="fw-semibold">upload files</span>');
  readonly customIcon = input('fas fa-upload fs-2 light-gray');
  readonly filesAdded = output<FileUpload[]>();
  readonly label = viewChild.required<ElementRef>('label');
  readonly fileInput = viewChild.required<ElementRef>('fileInput');

  dragEvent$!: Subscription;
  dropEvent$!: Subscription;
  domEvents$ = new BehaviorSubject<string | null>(null);
  uniqueId = 'nts-file-upload-' + Math.floor(Math.random() * 1000000);
  stylesMain: Record<string, string> = {};
  subtext: string | null = '<div>Drop file here or <span style="font-weight: bold; color:#138890;">browse</span></div>';
  isHover = false;
  trustedHtml: any;

  constructor() {
    this.trustedHtml = this._sanitizer.bypassSecurityTrustHtml(this.subtext);
  }

  ngOnInit() {
    this.stylesMain = {
      'min-height': '180px',
    };
  }

  ngAfterViewInit(): void {
    // Stop drag events, set highlight
    this.dragEvent$ = merge(
      fromEvent<DragEvent>(this.label().nativeElement, 'dragleave'),
      fromEvent<DragEvent>(this.label().nativeElement, 'dragover'),
    )
      .pipe(
        map((e) => {
          e.preventDefault();
          e.stopPropagation();

          return e.type;
        }),
        distinctUntilChanged(),
        // debounceTime(100),
        tap((type) => {
          this.domEvents$.next(type);
        }),
      )
      .subscribe();

    // Capture drop event
    this.dropEvent$ = fromEvent<DragEvent>(this.label().nativeElement, 'drop')
      .pipe(
        map((e) => {
          e.preventDefault();
          e.stopPropagation();

          return e;
        }),
        tap((e) => {
          this.domEvents$.next(e.type);
        }),
        filter((e) => !!e.dataTransfer),
      )
      .subscribe((e) => {
        if (e.dataTransfer) {
          this.filesAdd(e);
        }
      });
  }

  ngOnDestroy() {
    this.dragEvent$.unsubscribe();
    this.dropEvent$.unsubscribe();
  }
  /**
   * Create a filelist
   * @param fileList
   */
  filesAdd(event: Event) {
    const fileList = (event.target as HTMLInputElement)?.files || (event as DragEvent).dataTransfer.files;
    const files: FileUpload[] = Object.keys(fileList).map((key: string) => {
      const file: File = fileList[parseInt(key, 10)];

      return {
        file,
        get formData() {
          const formData: FormData = new FormData();
          formData.append('file', file, file.name);

          return formData;
        },
        get fileReader() {
          const reader = new FileReader();
          reader.readAsDataURL(file);

          // reader.onload = function() {};
          // reader.onerror = function() {};
          return reader;
        },
        get objectUrl() {
          return URL.createObjectURL(file);
        },
      };
    });
    this.filesAdded.emit(files);
    this.fileInput().nativeElement.value = '';
    this.subtext = 'Uploaded!';
    this.trustedHtml = this._sanitizer.bypassSecurityTrustHtml(this.subtext);
  }
}
